import { useNode, useEditor } from "@craftjs/core";
import React, { useContext, useEffect, useMemo } from "react";
import { ContainerSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import classNames from "classnames";
import { CMSContainerSettings } from "./cms-settings";
import icon from "./icon";
import { GrigoraEditorContext } from "../../editor/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faLinkSlash,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Toast from "../../toast/toast";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";
import { GrigoraPreviewContext } from "../../post-preview/context";
import { GrigoraDashboardContext } from "../../dashboard/context";
import slugify from "slugify";

export const Container = (props) => {
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node },
  } = useEditor();

  const childrens = node(id).childNodes();
  const parents = node(id).ancestors();

  const previewContext = useContext(GrigoraPreviewContext);
  const editorContext = useContext(GrigoraEditorContext);
  const { domain, cmsPosts } = useContext(GrigoraDashboardContext);

  var {
    children,
    Tag = "div",
    display = "block",
    url,
    isUrlDynamic,
    dynamicUrlSrc,
    openInNewTab,
    backgroundOverlayLayer,
    backgroundOverlayLayerTablet,
    backgroundOverlayLayerMobile,
    isComponent,
    componentID,
    hoverBackgroundLayer,
    hoverBackgroundLayerTablet,
    hoverBackgroundLayerMobile,
    hoverBackgroundOverlayLayer,
    hoverBackgroundOverlayLayerTablet = 0.7,
    hoverBackgroundOverlayLayerMobile,
    isBackgroundLayerDynamic,
    hoverIsBackgroundLayerDynamic,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-container": true,
      [`container-${id}`]: id,
      [`is-flex`]: display === "flex",
      [`is-block`]: display !== "flex",
      [`has-background-hover`]:
        isBackgroundLayerDynamic ||
        hoverIsBackgroundLayerDynamic ||
        hoverBackgroundLayer?.mode === "color" ||
        hoverBackgroundLayer?.mode === "gradient" ||
        hoverBackgroundLayer?.mode === "image" ||
        hoverBackgroundLayerTablet?.mode === "color" ||
        hoverBackgroundLayerTablet?.mode === "gradient" ||
        hoverBackgroundLayerTablet?.mode === "image" ||
        hoverBackgroundLayerMobile?.mode === "color" ||
        hoverBackgroundLayerMobile?.mode === "gradient" ||
        hoverBackgroundLayerMobile?.mode === "image"
          ? true
          : false,
      [`has-overlay`]:
        hoverBackgroundOverlayLayer?.mode === "color" ||
        hoverBackgroundOverlayLayer?.mode === "gradient" ||
        hoverBackgroundOverlayLayer?.mode === "image" ||
        hoverBackgroundOverlayLayerTablet?.mode === "color" ||
        hoverBackgroundOverlayLayerTablet?.mode === "gradient" ||
        hoverBackgroundOverlayLayerTablet?.mode === "image" ||
        hoverBackgroundOverlayLayerMobile?.mode === "color" ||
        hoverBackgroundOverlayLayerMobile?.mode === "gradient" ||
        hoverBackgroundOverlayLayerMobile?.mode === "image" ||
        backgroundOverlayLayer ||
        backgroundOverlayLayerTablet ||
        backgroundOverlayLayerMobile
          ? true
          : false,
    },
    blockProps.className,
  );

  // const hasParentAnchorFn = (parents) => {
  //   for (let i = 0; i < parents.length; i++) {
  //     if (node(parents[i]).get().data.custom.slug === "grigora/container") {
  //       if (!!node(parents[i]).get().data.props.url) return true;
  //     }
  //   }
  //   return false;
  // };

  // var hasParentAnchor = useMemo(() => hasParentAnchorFn(parents), [parents]);

  // useEffect(() => {
  //   if (hasParentAnchor) {
  //     setProp((props) => {
  //       props.url = "";
  //     });
  //   }
  // }, [hasParentAnchor]);

  if (isUrlDynamic) {
    if (dynamicUrlSrc === "current-cms-post") {
      url = `https://${domain}/${cmsPosts?.[0]?.slug}`;
    } else if (dynamicUrlSrc === "current-cms-category") {
      url = `https://${domain}/category/${slugify(
        cmsPosts?.[0]?.category?.[0]?.label ?? "",
        {
          trim: false,
          lower: true,
        },
      )}`;
    }
  }

  var content = url ? (
    <a
      href={url}
      onMouseMove={(e) => {
        e.preventDefault();
        return;
      }}
      onClick={(e) => {
        e.preventDefault();
        return;
      }}
      target={openInNewTab ? "_blank" : ""}
      rel="noreferrer"
    >
      <div className="childrens">
        {Array.isArray(childrens) && childrens.length === 0 ? (
          <>
            <div className="empty-container"></div>
          </>
        ) : null}
        {children}
      </div>
    </a>
  ) : (
    <div className="childrens">
      {Array.isArray(childrens) && childrens.length === 0 ? (
        <>
          <div className="empty-container"></div>
        </>
      ) : null}
      {children}
    </div>
  );

  return (
    <Tag
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Container(
        id,
        props,
        {
          CMSPostContext: {
            featured_image: {
              src: previewContext?.postData?.featured_image?.src
                ? previewContext?.postData?.featured_image?.src
                : cmsPosts?.[0]?.featured_image?.src
                ? cmsPosts?.[0]?.featured_image?.src
                : "",
              srcMode: previewContext?.postData?.featured_image?.srcMode
                ? previewContext?.postData?.featured_image?.srcMode
                : cmsPosts?.[0]?.featured_image?.srcMode
                ? cmsPosts?.[0]?.featured_image?.srcMode
                : "",
            },
          },
        },
        editorContext?.projectID,
      )}`}</style>

      {hoverBackgroundLayer?.mode === "color" ||
      hoverBackgroundLayer?.mode === "gradient" ||
      hoverBackgroundLayer?.mode === "image" ||
      hoverBackgroundLayerTablet?.mode === "color" ||
      hoverBackgroundLayerTablet?.mode === "gradient" ||
      hoverBackgroundLayerTablet?.mode === "image" ||
      hoverBackgroundLayerMobile?.mode === "color" ||
      hoverBackgroundLayerMobile?.mode === "gradient" ||
      hoverBackgroundLayerMobile?.mode === "image" ||
      isBackgroundLayerDynamic ||
      hoverIsBackgroundLayerDynamic ? (
        <div className="hover-container"></div>
      ) : (
        <></>
      )}

      {backgroundOverlayLayer ||
      backgroundOverlayLayerTablet ||
      backgroundOverlayLayerMobile ? (
        <>
          <div className="overlay"></div>
          {hoverBackgroundOverlayLayer?.mode === "color" ||
          hoverBackgroundOverlayLayer?.mode === "gradient" ||
          hoverBackgroundOverlayLayer?.mode === "image" ||
          hoverBackgroundOverlayLayerTablet?.mode === "color" ||
          hoverBackgroundOverlayLayerTablet?.mode === "gradient" ||
          hoverBackgroundOverlayLayerTablet?.mode === "image" ||
          hoverBackgroundOverlayLayerMobile?.mode === "color" ||
          hoverBackgroundOverlayLayerMobile?.mode === "gradient" ||
          hoverBackgroundOverlayLayerMobile?.mode === "image" ? (
            <div className="hover-overlay"></div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
      {content}
      {isComponent && (
        <div className="component-overlay">
          <div
            onClick={(e) => {
              if (
                editorContext?.setLeftWidget &&
                editorContext?.changeCurrentPage
              ) {
                if (
                  editorContext?.projectComponents &&
                  editorContext?.projectComponents["component-" + componentID]
                ) {
                  editorContext.setLeftWidget("");
                  editorContext.changeCurrentPage("component-" + componentID);
                  editorContext?.setPrevPage(editorContext?.currentPage);
                } else {
                  toast.error(
                    <Toast
                      title={"Error"}
                      description={"No Component Found."}
                    />,
                  );
                }
              }
            }}
            // title={"Edit Component"}
            className="edit-template-btn edit"
          >
            Edit{" "}
            {editorContext?.projectComponents["component-" + componentID]
              ?.title ?? "Component"}
          </div>
          <div
            onClick={(e) => {
              setProp((props) => {
                props.isComponent = undefined;
                props.componentID = undefined;
              });
            }}
            // title={"Detach Component"}
            className="edit-template-btn detach"
          >
            Detach
          </div>
        </div>
      )}
    </Tag>
  );
};

// To Avoid Mangling in Production
Container.displayName = "Container";

Container.craft = {
  name: "Container",
  props: {},
  related: {
    settings: ContainerSettings,
    CMSsettings: CMSContainerSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    category: "layout",
    supports: [
      "grigora/directory-conditional",
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
      "grigora/transition",
    ],
    keywords: ["Container", "Parent", "Group"],
    supportNestedBlocks: true,
  },
  custom: {
    name: "Container",
    slug: "grigora/container",
  },
};
